import { Component, Input, OnInit } from '@angular/core';
import { LayoutTopbarMenu } from 'src/app/components/layout/models/interface/layoutTopbarMenu.interface';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { LayoutMenuActions } from '../../layout.page.component.actions.enum';

@Component({
  selector: 'app-topbar-menu',
  templateUrl: './topbar-menu.component.html',
  styleUrls: ['./topbar-menu.component.sass'],
})
export class TopbarMenuComponent implements OnInit {
  @Input() loginActionsMenu: Actions<LayoutMenuActions, any>;
  @Input() layoutTopbarMenuList: LayoutTopbarMenu[];

  layoutMenuActions = LayoutMenuActions;

  constructor() {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * Click to action
   * @param actionMenu Action of menu
   */
  clickItemMenu(actionMenu: LayoutMenuActions) {
    this.loginActionsMenu.emit(actionMenu, null);
  }
}
